import { useTranslation } from 'react-i18next'
import DividerLine from "../DividerLine"
import alert from '../../assets/images/contact/alert.svg'
import { useRef } from 'react'
import emailjs from '@emailjs/browser'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Contact = () => {
    const { t } = useTranslation()

    const form = useRef()
    const sendEmail = (e) => {
        e.preventDefault()
        const sendButton = document.getElementById('sendButton')
        sendButton.innerHTML = 'Sending...'
        sendButton.style.fontSize = '1.2rem'
        emailjs.sendForm('service_6u4ljhg', 'template_a46xb66', form.current, 'g5TX7imVVLB2Hsy8y')
            .then(() => {
                sendButton.style.fontSize = '1.5rem'
                sendButton.innerHTML = 'Send message'
                toast.success('¡Success! you will recieve a response in no time', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    closeOnClick: true,
                    closeButton: false,
                    icon: '🚀'
                })
                e.target.reset()
            }, (error) => {
                console.log(error.text)
                sendButton.style.fontSize = '1.5rem'
                sendButton.innerHTML = 'Send message'
                toast.error('Error, please try again ', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    closeOnClick: true,
                    closeButton: false,
                    icon: '⚠️'
                })
            })
    }

    return (
        <div>
            <div className="px-10 mb-10">
                <div className="flex gap-x-10">
                    <h1 className="h1-macro py-14 flex-col no-selection">{ t('contact_title') }</h1>
                    <img src={alert} alt="error" className="w-24" />
                </div>
                
                <div className="flex flex-wrap gap-x-10 gap-y-2 items-center mt-4">
                    <div className="flex gap-x-4">
                        <p>Instagram:</p>
                        <a href="https://www.instagram.com/binarybrains.dev/" target="_blank" rel="noreferrer">
                            <div className="flex items-center grow">
                                <p className="font-semibold underline bg-indigo-400 text-white px-1 rounded-sm">@binarybrains.dev</p>
                            </div>
                        </a>
                    </div>
                    {/* <a href="" target="_blank" rel="noreferrer">
                        <div className="flex items-center mt-8 grow">
                            <p className="text-4xl font-bold">linkedIn</p>
                        </div>
                    </a> */}
                    <div className="flex gap-x-4">
                        <p>Email:</p>
                        <a href="mailto:binarybrains.dev@gmail.com" target="_blank" rel="noreferrer">
                            <div className="flex items-center grow">
                                <p className="font-semibold underline bg-indigo-400 text-white px-1 rounded-sm">binarybrains.dev@gmail.com</p>
                            </div>
                        </a>
                    </div>
                    <div className="flex gap-x-4">
                        <p>Whatsapp:</p>
                        <a href="https://wa.me/5491131918140" target="_blank" rel="noreferrer">
                            <div className="flex items-center grow">
                                <p className="font-semibold underline bg-indigo-400 text-white px-1 rounded-sm">+54 9 11 31918140</p>
                            </div>
                        </a>
                    </div>
                </div> 
            </div>

            <DividerLine mt={''} mb={'12'}/>

            <div className="px-10">

                <div className="contact-form">
                    <form className="mt-11 mx-auto w-full" ref={form} onSubmit={sendEmail}>
                        <h3 className="text-xl font-light mb-1.5">{ t('contact_form_name') } <span className='text-red-500 select-none'>*</span></h3>
                        <input className="w-full bg-default mb-10 h-10 px-3 text-xl border-2 border-gray-300 focus:border-indigo-500 rounded-md focus:outline-none" type="text" id="user_name" name="user_name" maxLength="40" required />
                        <h3 className="text-xl font-light mb-1.5">{ t('contact_form_email') } <span className='text-red-500 select-none'>*</span></h3>
                        <input className="w-full bg-default mb-10 h-10 px-3 text-xl border-2 border-gray-300 focus:border-indigo-500 rounded-md" type="email" id="user_email" name="user_email" maxLength="40" required />
                        <h3 className="text-xl font-light mb-1.5">{ t('contact_form_phone') }</h3>
                        <input className="w-full bg-default mb-10 h-10 px-3 text-xl border-2 border-gray-300 focus:border-indigo-500 rounded-md" type="tel" id="user_phone" name="user_phone" maxLength="40" />
                        <h3 className="text-xl font-light mb-1.5">{ t('contact_form_message') } <span className='text-red-500 select-none'>*</span></h3>
                        <textarea className="w-full bg-default mb-6 h-64 px-3 text-xl py-3 resize-none border-2 border-gray-300 focus:border-indigo-500 rounded-md" id='message' name="message" required></textarea><br />
                        <button id='sendButton' className='sendButton rounded-md text-xl bg-accent text-white px-8 py-3 mb-10 grow'>{ t('contact_form_button') }</button>
                    </form>
                </div>
                <div className="flex justify-between items-center">
                    <a href="mailto:binarybrains.dev@gmail.com" target="_blank" rel="noreferrer">
                        <p className="text-2xl">{ t('contact_form_alttext') } <span className="text-accent">binarybrains.dev@gmail.com</span></p>
                    </a>
                </div>
            </div>

        </div>
    )
}

export default Contact